<template>
  <StModal :open="true" :title="`Delete Battleplan “${name}”?`" @close="$emit('cancel')">
    <p class="modal-sub">This can’t be undone via the file — only via Undo.</p>
    <template #footer>
      <StButton variant="ghost" @click="$emit('cancel')">Cancel</StButton>
      <StButton variant="danger" @click="$emit('confirm')">Delete</StButton>
    </template>
  </StModal>
</template>

<script setup lang="ts">
import { StModal, StButton } from '../ui/index.js';

defineProps<{ name: string }>();
defineEmits<{ confirm: []; cancel: [] }>();
</script>

<style scoped>
.modal-sub {
  margin: 0;
  font-size: var(--st-text-md);
  color: var(--st-text-muted);
}
</style>
